import { useEffect } from "react";

import { formatDateTime, formatNumber } from "../../lib/format";
import { useOverlayDismiss } from "../../lib/useOverlayDismiss";

export interface ReceivedGumballDetail {
  id: string;
  giver: string;
  amount: number;
  reason: string | null;
  createdAt: string;
}

interface ReceivedGumballsModalProps {
  open: boolean;
  entries: ReceivedGumballDetail[];
  total: number;
  onClose: () => void;
}

export function ReceivedGumballsModal({
  open,
  entries,
  total,
  onClose
}: ReceivedGumballsModalProps) {
  const overlayDismiss = useOverlayDismiss(onClose);

  useEffect(() => {
    if (!open) {
      return;
    }
    const handler = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className="modal-overlay" role="presentation" {...overlayDismiss}>
      <div
        className="modal received-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="received-modal-title"
      >
        <header className="modal__header">
          <div>
            <h2 id="received-modal-title">Gumballs received</h2>
            <p className="received-modal__total">
              {formatNumber(total)} gumball{total === 1 ? "" : "s"} from your teammates
            </p>
          </div>
          <button type="button" className="modal__close" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </header>
        <div className="modal__body">
          {entries.length === 0 ? (
            <p className="received-modal__empty">No gumballs received yet.</p>
          ) : (
            <ul className="received-modal__list history__list">
              {entries.map((entry) => (
                <li key={entry.id} className="history__row">
                  <div className="history__row-text">
                    <strong>{entry.giver}</strong>
                    {entry.reason !== null && (
                      <span className="history__row-note">{entry.reason}</span>
                    )}
                    <time>{formatDateTime(entry.createdAt)}</time>
                  </div>
                  <span className="history__row-amount">{formatNumber(entry.amount)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
